import React from "react"

const Hi = props => (
  <svg viewBox="0 0 173.16 121.3" fill="none" {...props}>
    <path
      d="M54.36 36.784c-12.008 0-21.432 5.016-27.208 14.44V7.296H.096V120.08h27.056V79.496c0-10.792 6.08-18.392 16.112-18.544 8.664 0 13.984 5.776 13.984 15.048v44.08h27.056V68.248c0-19.304-11.856-31.464-29.944-31.464zM116.028 0c-8.36 0-14.288 5.928-14.288 14.44s5.928 14.44 14.288 14.44 14.288-5.928 14.288-14.44S124.388 0 116.028 0zM102.5 37.848v82.232h26.904V37.848H102.5zM147.565.136v41.208l4.56 41.8h16.415l4.713-41.8V.136h-25.688zM159.876 95c-7.6 0-12.919 5.32-12.919 13.072 0 7.752 5.319 13.224 12.919 13.224 7.601 0 13.073-5.472 13.073-13.224S167.477 95 159.876 95z"
      fill="#F2C94C"
    />
  </svg>
)

export default Hi
